export const NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION = "com.actimind.actitime.services.NoRightToEditHierarchyException"

// Task
export const NO_SUCH_TASK_EXCEPTION = "com.actimind.actitime.task.NoSuchTaskException"
export const TASK_UNAVAILABLE_EXCEPTION = "com.actimind.actitime.task.TaskUnavailableException"
export const TASK_CANNOT_BE_MODIFIED_EXCEPTION = "com.actimind.actitime.task.TaskCannotBeModifiedException"
export const TASK_ESTIMATE_DISABLED_EXCEPTION = "com.actimind.actitime.services.beans.taskmanagement.TaskEstimateDisabledException"
export const NO_RIGHTS_TO_MANAGE_TASK_EXCEPTION = "com.actimind.actitime.services.EditTaskService$NoRightsToManageTaskException"
export const TASK_EXISTS_EXCEPTION = "com.actimind.actitime.task.TaskExistsException"
export const ACTIVE_TASKS_PROJECT_IS_ARCHIVED_EXCEPTION = "com.actimind.actitime.task.ActiveTasksProjectIsArchivedException"
export const TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION = "com.actimind.actitime.task.TaskIsNotAssignedToUserException"

// Project
export const PROJECT_IS_NOT_AVAILABLE_EXCEPTION = "com.actimind.actitime.task.ProjectIsNotAvailableException"
export const PROJECT_CANNOT_BE_MODIFIED_EXCEPTION = "com.actimind.actitime.project.ProjectCannotBeModifiedException"
export const PROJECT_IS_ARCHIVED_EXCEPTION = "com.actimind.actitime.task.ProjectIsArchivedException"
export const NO_SUCH_PROJECT_EXCEPTION = "com.actimind.actitime.project.NoSuchProjectException"
export const PROJECT_IS_NOT_ASSIGNED_EXCEPTION = "com.actimind.actitime.project.ProjectIsNotAssignedException"
export const PROJECT_EXISTS_EXCEPTION = "com.actimind.actitime.project.ProjectExistsException"

// Customer
export const CUSTOMER_CANNOT_BE_MODIFIED_EXCEPTION = "com.actimind.actitime.customer.CustomerCannotBeModifiedException"
export const CUSTOMER_UNAVAILABLE_EXCEPTION = "com.actimind.actitime.customer.CustomerUnavailableException"
export const NO_SUCH_CUSTOMER_EXCEPTION = "com.actimind.actitime.customer.NoSuchCustomerException"
export const CUSTOMER_IS_NOT_ASSIGNED_EXCEPTION = "com.actimind.actitime.customer.CustomerIsNotAssignedException"
export const CUSTOMER_ARCHIVED_EXCEPTION = "com.actimind.actitime.customer.CustomerArchivedException"

// Statuses
export const WORKFLOW_STATUS_CHANGED_EXCEPTION = "com.actimind.actitime.services.WorkflowStatusChangedException"
export const NO_SUCH_WORKFLOW_STATUSES_EXCEPTION = "com.actimind.actitime.administration.NoSuchWorkflowStatusException"
export const WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION = "com.actimind.actitime.services.WorkflowStatusesFeatureBecameEnabledException"
export const WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION = "com.actimind.actitime.services.WorkflowStatusesFeatureBecameDisabledException"





// WEBPACK FOOTER //
// ./web/js/taskManagement/common/ExceptionsTypes.js